module.exports = __webpack_public_path__ + "img/no-image.c63b281f.svg";